import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_ctx.date)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: 'exact-date', params: { date: _ctx.formattedDate } }
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"]))
    : (_openBlock(), _createBlock("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}